import { STAGE_LABEL, type CasePhoto } from '@/domain';
import { strings } from '@/shared/strings';
import type { PhotoViewerItem } from './photoViewerStore';

/**
 * A stored photograph as the image viewer takes it, captioned the same from
 * wherever it is opened: the strip on a case, the edit screen, the record's
 * card, the camera on a history row. The request of 5 October 2026 (third),
 * section 6.
 */

/** Where a case photograph was taken, as its tile says it: the stage, or reception for one taken at intake. */
export function casePhotoCaption(photo: CasePhoto): string {
  return photo.stage === 'intake' ? strings.job.photoFromIntake : STAGE_LABEL[photo.stage];
}

/** A case photograph. */
export function casePhotoItem(photo: CasePhoto): PhotoViewerItem {
  return { kind: 'photo', photo, caption: casePhotoCaption(photo) };
}

/** A proof of work: what it is and where it was taken, since nothing else on it says it is a proof. */
export function proofItem(proof: CasePhoto): PhotoViewerItem {
  return {
    kind: 'photo',
    photo: proof,
    caption: `${strings.proof.cardTitle} · ${STAGE_LABEL[proof.stage]}`,
  };
}
